import type { IconData } from '@stacksjs/iconify-core'

export const basicUiMuteNotifications: IconData = {
  "body": "<path fill=\"currentColor\" d=\"m0 1l1-1l2.287 2.287A6 6 0 0 1 14 6v3.5l2 2h-3.5L16 15l-1 1zm2.071 4.071A6 6 0 0 0 2 6v3.5l-2 2h8.5zM10 13H5a3 3 0 0 0 5.872.872z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default basicUiMuteNotifications
